(() => {
  function triggerBodyEvent(name, payload) {
    if (!window.jQuery) return;
    window.jQuery('body').trigger(name, payload);
  }

  function addToCart(variantId, qty) {
    const data = new URLSearchParams();
    data.append('id', String(variantId));
    data.append('quantity', String(qty));

    if (window.theme && theme.cart && typeof theme.cart.addItemFromForm === 'function') {
      const request = theme.cart.addItemFromForm(data.toString());
      return new Promise((resolve, reject) => {
        request.then(resolve, reject);
      });
    }

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'application/json'
      },
      body: data.toString()
    }).then((response) => {
      if (!response.ok) {
        return response.json().then((json) => Promise.reject(json));
      }
      return response.json();
    });
  }

  class AddToCartBtn extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this._loading = false;

      if (!this.hasAttribute('role')) {
        this.setAttribute('role', 'button');
      }
      if (!this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', '0');
      }

      this.updateDisabledState();
      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    getQtyLimit() {
      const limit = parseInt(this.dataset.qtyLimit || '', 10);
      return Number.isFinite(limit) ? limit : null;
    }

    updateDisabledState() {
      const qtyLimit = this.getQtyLimit();
      const isDisabled = qtyLimit === 0;
      this.classList.toggle('disabled', isDisabled);
      this.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
      return isDisabled;
    }

    decrementQtyLimit(qty) {
      const qtyLimit = this.getQtyLimit();
      if (qtyLimit === null) return;
      const nextLimit = Math.max(0, qtyLimit - qty);
      this.dataset.qtyLimit = String(nextLimit);
      this.updateDisabledState();
    }

    handleKeydown(evt) {
      if (evt.key !== 'Enter' && evt.key !== ' ') return;
      evt.preventDefault();
      this.click();
    }

    setLoading(state) {
      this._loading = state;
      this.classList.toggle('btn--loading', state);
      this.classList.toggle('is-loading', state);
      this.setAttribute('aria-busy', state ? 'true' : 'false');
    }

    async handleClick(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      if (this._loading || this.updateDisabledState()) return;

      const variantId = this.dataset.variantId;
      const qty = Math.max(1, parseInt(this.dataset.qty || '1', 10) || 1);
      const qtyLimit = this.getQtyLimit();

      if (!variantId) {
        const errorMessage = 'Missing data-variant-id on <add-to-cart-btn>.';
        console.warn(errorMessage);
        document.dispatchEvent(new CustomEvent('error:ajaxProduct', {
          detail: { errorMessage: errorMessage }
        }));
        return;
      }

      if (qtyLimit !== null && qty > qtyLimit) {
        this.updateDisabledState();
        return;
      }

      this.setLoading(true);

      try {
        const product = await addToCart(variantId, qty);
        this.decrementQtyLimit(qty);

        triggerBodyEvent('added.ajaxProduct');
        document.dispatchEvent(new CustomEvent('added:ajaxProduct', {
          detail: { product: product }
        }));
      } catch (error) {
        const message = error && error.description ? error.description : 'Unable to add item to cart.';
        console.warn(message);
        document.dispatchEvent(new CustomEvent('error:ajaxProduct', {
          detail: { errorMessage: message }
        }));
      } finally {
        this.setLoading(false);
      }
    }
  }

  if (!customElements.get('add-to-cart-btn')) {
    customElements.define('add-to-cart-btn', AddToCartBtn);
  }
})();
